import { PathGoal } from 'types/types'

export const computeUserCount = (props: { _id: string; enrolled_users_count: number; short_description: string }) => {
    const fakeUserCount = props._id
        .split('')
        .reduce((acc, curr) => (isNaN(parseInt(curr)) ? acc : acc + parseInt(curr)), props.short_description.length * 3)

    return fakeUserCount + props.enrolled_users_count
}

export const colorsFromItemType = (type: PathGoal) => {
    switch (type) {
        case 'career':
            return ['#E86767', '#E8676730']
        case 'skill':
            return ['secondary.main', 'secondary.light']
        case 'course':
            return ['#d667e8', '#d667e830']
    }
}
